import { useState } from 'react';
import { api } from '../lib/api.js';
import { Field, Banner } from '../components/ui.jsx';
import { Entrance, Centered } from './Entrance.jsx';

export function SignIn({ onSignedIn, onMfaRequired }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const res = await api.signIn(username, password);
      if (res.mfaRequired) onMfaRequired(res.user);
      else onSignedIn();
    } catch (err) {
      if (err.unreachable) {
        setError({ tone: 'warning', text: 'EPMS is not answering. The till is fine, the server is not. Try again in a moment, and tell whoever runs the system if it keeps happening.' });
      } else if (err.status === 423) {
        setError({ tone: 'danger', text: `Too many attempts. Try again in ${err.data.minutes} minutes. This attempt was recorded in the audit log.` });
      } else if (err.data?.locked) {
        setError({ tone: 'danger', text: `Too many attempts. Locked for ${err.data.minutes} minutes.` });
      } else if (err.data?.offline) {
        // The till answered, not the server. Saying "wrong password" here sends somebody
        // hunting for a password problem that does not exist, which is exactly what it did.
        setError({ tone: 'warning', text: err.data.detail
          || 'This till cannot reach EPMS. Signing in for the first time on a machine needs a connection.' });
      } else {
        setError({ tone: 'danger', text: 'That username and password do not match.' });
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <Entrance>
      <form onSubmit={submit} style={{ display: 'grid', gap: 20 }}>
        <h1>Sign in</h1>
        <div className="lede">Use the account you were handed. It is yours, not the till's.</div>

        <Field id="username" label="Username" value={username} autoComplete="username" autoFocus
          placeholder="your username" onChange={e => setUsername(e.target.value)} />
        <Field id="password" label="Password" type="password" value={password} autoComplete="current-password"
          placeholder="your password" onChange={e => setPassword(e.target.value)} />

        <button className="btn-ezel" type="submit" disabled={busy || !username || !password}>
          {busy ? 'Signing in' : 'Sign in'}
        </button>

        {error && <Banner tone={error.tone}>{error.text}</Banner>}

        <div className="entrance-help">
          Forgotten it, or locked out? An owner or an admin can issue you a new password from
          Users and roles. Nobody, including them, can read your current one.
        </div>
      </form>
    </Entrance>
  );
}

export { Centered };
